import {
  CommonMFE,
  Helpers,
  MFE_NAMES,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import React from "react";

type TTitleWrapperProps = {
  id: string;
  __host__: CommonMFE.Types.THost;
  isEditMode: boolean;
  config: any;
};

/** It manages the logic to show the Title */
export const TitleWrapper = (props: TTitleWrapperProps) => {
  const { id: containerID, isEditMode, __host__, config } = props;

  const title = config["Title"];
  const iconName = Helpers.RemoteHelper.getIconClassName(config["iconaBox"], {
    Casa: "Casa2",
    Lavoro: "Business",
  });

  return (
    <div className="box-title">
      {iconName && <i className={iconName} />}
      {(title?.value?.value || isEditMode) && (
        <div className="text">
          <ReactMFE.Remote
            id={CommonMFE.generateID(
              containerID,
              `${MFE_NAMES.tpdVisoreNoCarosello}-Titolo`
            )}
            __deps__={React}
            __host__={__host__}
            __mfeName__={MFE_NAMES.tpdShortText}
            isEditMode={isEditMode}
            {...title}
          />
        </div>
      )}
    </div>
  );
};
